import { render, staticRenderFns } from "./WidgetTextMode.vue?vue&type=template&id=78b395f0&"
import script from "./WidgetTextMode.vue?vue&type=script&lang=js&"
export * from "./WidgetTextMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetTextMode.vue"
export default component.exports